import React from 'react'
import { Table, Typography } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { IMovementRS } from '../../../../models/storageModel'
import { getTransferSummary, TTransferGroup } from '../../../../utils/reportUtils'
import { TExcelColumn } from '../../../../utils/excelExport'
import { textNumberFormater } from '../../../../utils'

const { Text } = Typography

interface TransfersBetweenStorehousesReportProps {
  data: IMovementRS[]
  storehouseMap: Map<string | number, string>
  loading?: boolean
}

export const transferExcelColumns: TExcelColumn[] = [
  { header: 'Nº Documento', key: 'documentNumber', width: 18 },
  { header: 'Fecha', key: 'createdAt', width: 20 },
  { header: 'Almacén Origen', key: 'fromStorehouse', width: 25 },
  { header: 'Almacén Destino', key: 'toStorehouse', width: 25 },
  { header: 'Nº Items', key: 'itemsCount', width: 12, format: 'number' },
  { header: 'Monto Total', key: 'totalAmount', width: 18, format: 'money' },
  { header: 'Responsable', key: 'userName', width: 25 }
]

export function getTransferExcelData(data: IMovementRS[], storehouseMap: Map<string | number, string>) {
  return getTransferSummary(data, storehouseMap)
}

export const TransfersBetweenStorehousesReport: React.FC<TransfersBetweenStorehousesReportProps> = ({
  data,
  storehouseMap,
  loading = false
}) => {
  const transfers = getTransferSummary(data, storehouseMap)

  const columns: ColumnsType<TTransferGroup> = [
    {
      title: '#',
      key: 'index',
      width: 50,
      render: (_, __, index) => index + 1
    },
    {
      title: 'Nº Documento',
      dataIndex: 'documentNumber',
      key: 'documentNumber',
      width: 140,
      render: (text) => <strong>{text}</strong>
    },
    {
      title: 'Fecha',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 150,
      render: (text) => (text ? new Date(text).toLocaleString() : '-')
    },
    {
      title: 'Almacén Origen',
      dataIndex: 'fromStorehouse',
      key: 'fromStorehouse',
      render: (text) => <Text style={{ color: '#ff4d4f' }}>{text}</Text>
    },
    {
      title: 'Almacén Destino',
      dataIndex: 'toStorehouse',
      key: 'toStorehouse',
      render: (text) => <Text style={{ color: '#52c41a' }}>{text}</Text>
    },
    {
      title: 'Items Movidos',
      dataIndex: 'itemsCount',
      key: 'itemsCount',
      width: 120,
      align: 'right',
      render: (val) => textNumberFormater(val)
    },
    {
      title: 'Monto Valorizado',
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      width: 160,
      align: 'right',
      sorter: (a, b) => a.totalAmount - b.totalAmount,
      render: (val) => <Text strong style={{ color: '#1890ff' }}>$ {textNumberFormater(val)}</Text>
    },
    {
      title: 'Responsable',
      dataIndex: 'userName',
      key: 'userName',
      render: (text) => text || '-'
    }
  ]

  return (
    <div style={{ overflowX: 'auto', width: '100%' }}>
      <Table<TTransferGroup>
        columns={columns}
        dataSource={transfers}
        loading={loading}
        pagination={{
          defaultPageSize: 15,
          showSizeChanger: true,
          pageSizeOptions: ['15', '30', '50'],
          showTotal: (total) => `Total ${total} transferencias`
        }}
        size="small"
        bordered
        scroll={{ x: 'max-content' }}
      />
    </div>
  )
}

export default TransfersBetweenStorehousesReport
